import React from 'react';
import {FadeInContainer, Card, Text, Button, Container, Colors} from '~/ui';
import GooglePlayStoreButton from '~/components/GooglePlayStoreButton';
import AppStoreButton from '~/components/AppStoreButton';

const WelcomeInfo = ({toggleModal, navigate}) => (
  <FadeInContainer show style={{paddingLeft: 14, paddingRight: 14}}>
    <Card
      style={{
        maxWidth: 800,
        borderRadius: 20,
        padding: 24,
        backgroundColor: Colors.white,
        margin: '0px auto',
      }}>
      <Text
        textType="h3"
        style={{color: Colors.secondaryColor, paddingBottom: 24}}>
        Så här kommer du igång med My Driving Academy Online!
      </Text>
      <Container
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          maxWidth: '90%',
          margin: 'auto'
        }}>
          <Container style={{paddingRight: '4px', width: '100%'}}>
            <GooglePlayStoreButton />
          </Container>
          <Container style={{paddingLeft: '4px', width: '100%'}}>
            <AppStoreButton />
          </Container>
      </Container>
    </Card>
  </FadeInContainer>
);

export default WelcomeInfo;
